export enum footerDataActionTypes {
    SetFooterDataType = "SET_FOOTERDATA",
}

export const setFooterData = (data: any) => ({
    type: footerDataActionTypes.SetFooterDataType,
    payload: data
});
